import React, { createContext, useContext, useReducer } from 'react';
import { wineAppReducer, initialState } from './wineAppReducer';

// Create the context
const WineAppContext = createContext();

// Custom hook to use the wine app context
export const useWineAppContext = () => {
    const context = useContext(WineAppContext);
    if (!context) {
        throw new Error('useWineAppContext must be used within a WineAppProvider');
    }
    return context;
};

// Provider component
export const WineAppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(wineAppReducer, initialState);

    const value = {
        state,
        dispatch
    };

    return (
        <WineAppContext.Provider value={value}>
            {children}
        </WineAppContext.Provider>
    );
};

export default WineAppContext;
